import { SweetModal } from './main.js'

export default {
	install(Vue, options) {
		Vue.component('SweetModal', SweetModal)
	}
}